import { QueryClient } from '@tanstack/react-query';

/** Default: cache agency list/report data; user can force refresh from the page. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1000,
      gcTime: 60 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
